export default "__VITE_ASSET__cKIUc08x__"